export const arrayToIdList = value =>
  value.length ? value.map(item => item.id) : undefined;

export const extractNodes = connection =>
  (connection?.edges ?? []).map(edge => edge.node);
